var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 53.74,
    viewBox: "0 0 187 53.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NT_manager-portal_logo_black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 9.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M109.382,101.545a3.28,3.28,0,0,0-2.331.96l-9.294,9.358A12.377,12.377,0,0,0,77.1,104.621L56.19,125.534l5.791-.009a3.28,3.28,0,0,0,2.331-.96l9.306-9.282v.009a12.377,12.377,0,0,0,20.642,7.16l20.818-20.913ZM85.634,120.3a6.763,6.763,0,1,1,6.763-6.763A6.763,6.763,0,0,1,85.634,120.3Z",
    transform: "translate(-56.19 -101.321)",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(79.718 44.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M318.414,222.252a1.833,1.833,0,0,1-1.682-.91v.793H315.4V214.52h1.353v2.836a1.86,1.86,0,0,1,1.67-.824,2.537,2.537,0,0,1,2.528,2.823A2.592,2.592,0,0,1,318.414,222.252Zm1.141-2.9c0-1.11-.612-1.7-1.405-1.7-.824,0-1.418.624-1.418,1.7,0,1.123.624,1.778,1.418,1.778S319.555,220.483,319.555,219.351Z",
    transform: "translate(-315.4 -214.52)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M337.043,228.949h-1.4l.993-2.4-2.19-5.087h1.439l1.418,3.564,1.31-3.564h1.375Z",
    transform: "translate(-328.591 -219.326)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M366.3,217.094v5.511H364.89V215.2h1.787l3.3,5.5v-5.5h1.405v7.406H369.6Z",
    transform: "translate(-349.67 -214.991)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M390.25,223.886a2.882,2.882,0,1,1,2.888,2.888A2.769,2.769,0,0,1,390.25,223.886Zm4.367,0a1.5,1.5,0,1,0-2.974,0,1.506,1.506,0,1,0,2.974,0Z",
    transform: "translate(-367.23 -219.042)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M414.223,226.843H412.87v-5.48h1.322v.837a2.111,2.111,0,0,1,.434-.52,1.626,1.626,0,0,1,1.11-.36,1.887,1.887,0,0,1,.381.031v1.279c-.264-.022-.391-.022-.538-.022a1.19,1.19,0,0,0-1.353,1.279v2.955Z",
    transform: "translate(-382.894 -219.229)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M429.639,221.37a1.855,1.855,0,0,1-1.67.889,2.878,2.878,0,0,1,.009-5.72,1.859,1.859,0,0,1,1.639.793v-2.8h1.366v7.615h-1.344Zm.012-2.011c0-1.079-.6-1.7-1.418-1.7s-1.418.634-1.418,1.7c0,1.123.594,1.778,1.418,1.778C429.018,221.136,429.652,220.481,429.652,219.358Z",
    transform: "translate(-391.584 -214.527)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M448.39,214.52h1.375v1.27H448.39Zm.012,2.134h1.353v5.48H448.4Z",
    transform: "translate(-407.49 -214.52)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M456.68,223.886a2.767,2.767,0,0,1,2.823-2.836,2.481,2.481,0,0,1,2.6,2.094h-1.344a1.262,1.262,0,0,0-1.27-.95,1.5,1.5,0,0,0-1.418,1.691,1.554,1.554,0,0,0,1.418,1.744,1.264,1.264,0,0,0,1.27-.963h1.344a2.528,2.528,0,0,1-2.623,2.1A2.734,2.734,0,0,1,456.68,223.886Z",
    transform: "translate(-413.23 -219.042)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M475.848,216.427H473.48V215.2h6.2v1.227h-2.368v6.179h-1.461Z",
    transform: "translate(-424.864 -214.991)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M495.313,226.843H493.96v-5.48h1.322v.837a2.11,2.11,0,0,1,.434-.52,1.626,1.626,0,0,1,1.11-.36,1.888,1.888,0,0,1,.381.031v1.279c-.264-.022-.391-.022-.538-.022a1.19,1.19,0,0,0-1.353,1.279v2.955Z",
    transform: "translate(-439.045 -219.229)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M510.926,226.295a1.843,1.843,0,0,1-1.6.763,1.913,1.913,0,0,1-1.99-2.159V221.46h1.365v3.217c0,.781.424,1.218,1.067,1.218.581,0,1.123-.443,1.123-1.405v-3.026h1.353v5.48h-1.322Z",
    transform: "translate(-448.31 -219.326)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M527.18,224.894h1.279c.1.581.594.846,1.227.846.52,0,1.015-.2,1.015-.634,0-.391-.369-.56-1.1-.689l-.55-.1c-1.1-.191-1.765-.7-1.765-1.556,0-1.1,1.006-1.756,2.242-1.756a2.132,2.132,0,0,1,2.337,1.713h-1.258a1.017,1.017,0,0,0-1.11-.7c-.529,0-.932.243-.932.615,0,.348.307.486.932.594l.55.1c1.206.212,1.956.689,1.956,1.639,0,1.163-1.11,1.787-2.337,1.787A2.2,2.2,0,0,1,527.18,224.894Z",
    transform: "translate(-462.049 -219.014)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M545.77,222.472V219.5h-.919v-1.036h.919V217.13h1.344v1.332h1.27V219.5h-1.27V222.2c0,.581.178.677.615.677h.655v1.049c-.391.022-.624.022-1.089.022C546.363,223.951,545.77,223.678,545.77,222.472Z",
    transform: "translate(-474.285 -216.327)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M561.267,226.78a2.86,2.86,0,0,1-.055-5.72,2.693,2.693,0,0,1,2.749,2.952v.3h-4.18a1.51,1.51,0,0,0,1.522,1.405,1.346,1.346,0,0,0,1.27-.655h1.332A2.563,2.563,0,0,1,561.267,226.78Zm-1.492-3.438h2.793a1.3,1.3,0,0,0-1.375-1.227A1.367,1.367,0,0,0,559.775,223.342Z",
    transform: "translate(-483.674 -219.049)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M582.207,226.78a2.86,2.86,0,0,1-.055-5.72,2.693,2.693,0,0,1,2.749,2.952v.3h-4.176a1.51,1.51,0,0,0,1.522,1.405,1.346,1.346,0,0,0,1.27-.655h1.332A2.571,2.571,0,0,1,582.207,226.78Zm-1.492-3.438h2.792a1.3,1.3,0,0,0-1.375-1.227A1.367,1.367,0,0,0,580.716,223.342Z",
    transform: "translate(-498.174 -219.049)",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("text", {
    id: "eFIRDS",
    transform: "translate(78 31)",
    fill: "#000000",
    fontSize: 33,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "eFIRDS")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.4f65711c6e7050bf2250cca15b67f257.svg";
export { ForwardRef as ReactComponent };